import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Labels } from '@core/constants/labels';
import { ExamService } from '@core/services/exam-service/exam-service.service';
import { UserService } from '@core/services/user-service/user-service.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-patient-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
  providers: [UserService, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './create-patient-dialog.component.html',
  styleUrls: ['./create-patient-dialog.component.scss'],
})
export class CreatePatientDialogComponent {
  labels = Labels.REGISTER_EXAM;

  createPatientForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<CreatePatientDialogComponent>,
    private examService: ExamService,
    private datePipe: DatePipe,
  ) {
    this.createPatientForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      birthday: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl(''),
      gender: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email]),
      address: new FormControl(''),
    });
  }

  async onSubmit() {
    if (this.createPatientForm.valid) {
      try {
        const formData = { ...this.createPatientForm.value };
        formData.birthday = this.datePipe.transform(
          formData.birthday,
          'yyyy-MM-dd',
        );

        const createdPatient = await lastValueFrom(
          this.examService.createPatient(formData),
        );
        this.dialogRef.close(createdPatient);
      } catch (error) {
        console.error('Error creating patient:', error);
      }
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
